import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FlashlightIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6 1C5.44772 1 5 1.44772 5 2V2.5H11V2C11 1.44772 10.5523 1 10 1H6Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 4.58579V3.5H11V4.58579C11 4.851 10.8946 5.10536 10.7071 5.29289L10.2929 5.70711C10.1054 5.89464 10 6.149 10 6.41421V14C10 14.5523 9.55229 15 9 15H7C6.44772 15 6 14.5523 6 14V6.41421C6 6.149 5.89464 5.89464 5.70711 5.70711L5.29289 5.29289C5.10536 5.10536 5 4.851 5 4.58579ZM8 7C7.58579 7 7.25 7.33579 7.25 7.75V9.25C7.25 9.66421 7.58579 10 8 10C8.41421 10 8.75 9.66421 8.75 9.25V7.75C8.75 7.33579 8.41421 7 8 7Z"
		></path>
	</svg>
))
